export enum PageBuilderWidgetType {
  row = 'row',
  list = 'list',
  form = 'form',
  text = 'text',
  button = 'button',
}
